/* eslint-disable */
import React from 'react';
import clsx from 'clsx';
import { HashLink as Link } from 'react-router-hash-link';
import Grid from '@material-ui/core/Grid';

import Button from '../../components/Button';
import Instagram from '../../assets/svgComps/Instagram';
import Youtube from '../../assets/svgComps/Youtube';
import Email from '../../assets/svgComps/Email';
import { side1, side2 } from './constant';
import playStoreIcon from '../../assets/icons/google_play_badge.png';

const component = ({ classes }) => {
  // eslint-disable-next-line
  const donwload = props => <a {...props} href='#' />;
  // eslint-disable-next-line
  const donwloadBizz = props => <a {...props} href='#' />;

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} style={{ marginBottom: '20px' }}>
        <Grid container>
          <Grid item xs={12} md={3}>
            <Link to='/' style={{ textDecoration: 'none' }}>
              <h1 className={clsx(classes.header, classes.headerBrand)}>
                Ngamen Hub
              </h1>
            </Link>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container>
              <Grid item xs={6}>
                {side1.map((c, i) => {
                  if (c.link) {
                    return (
                      <Link
                        className={classes.link}
                        key={`side1-${i}`}
                        to={c.url}
                      >
                        {c.title}
                      </Link>
                    );
                  }
                  return (
                    <Link
                      smooth
                      className={classes.link}
                      key={`side1-${i}`}
                      to={c.url}
                    >
                      {c.title}
                    </Link>
                  );
                })}
              </Grid>
              <Grid item xs={6}>
                {side2.map((c, i) => {
                  if (c.link) {
                    return (
                      <Link
                        className={classes.link}
                        key={`side2-${i}`}
                        to={c.url}
                      >
                        {c.title}
                      </Link>
                    );
                  }
                  return (
                    <Link
                      smooth
                      className={classes.link}
                      key={`side2-${i}`}
                      to={c.url}
                    >
                      {c.title}
                    </Link>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={5}>
            <h2 className={classes.header}>Download</h2>
            <Grid container style={{ marginBottom: '20px' }} spacing={2}>
              <Grid item>
                <a
                  href='/'
                  style={{
                    display: 'block',
                    position: 'relative',
                    height: '50px',
                  }}
                >
                  <img
                    src={playStoreIcon}
                    alt=''
                    style={{ display: 'block', height: '100%' }}
                  />
                </a>
              </Grid>
            </Grid>
            <h2 className={classes.header}>Follow Us On</h2>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <a
                className={clsx(classes.colorWhite, classes.social)}
                href='https://www.instagram.com/ngamenhub/'
                target='_blank'
              >
                <Instagram />
              </a>
              <a
                className={clsx(classes.colorWhite, classes.social)}
                href='https://www.youtube.com/channel/UCDbj-fVgFx0AYAwCTm7FOsg'
                target='_blank'
              >
                <Youtube style={{ fontSize: '2rem' }} />
              </a>
              <a
                className={clsx(classes.colorWhite, classes.social)}
                href='mailto:ngamenhub@gmail.com'
                target='_blank'
              >
                <Email style={{ fontSize: '2rem' }} />
              </a>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className={clsx(classes.colorWhite, classes.divider)}>
        <p>© 2020 Ngamen Hub</p>
        <span>
          Registered in the Directorate General of Intellectual Property of the
          Republic of Indonesia.
        </span>
      </Grid>
    </Grid>
  );
};

export default component;
